import { Card, Row } from "antd";
import React from "react";
import { FormItem, Input } from "asumsi-components";
export const TopicSection = (props: any) => {
    const { setFieldsValues, fieldsValues } = props;
    return <Card className="topic-card-section" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div className="title-desc">
            <div className="title">TOPIC SECTION</div>
        </div>
        <Row>
            <FormItem width="100%" className="m-t-10" label="Title" labelAlign="left" fieldsValues={fieldsValues} setFieldsValues={setFieldsValues}
                fieldDecorator={{
                    label: "topicsTitle",
                    rules: [{
                        message: 'Please input title',
                        required: true,
                    }
                    ]
                }}
            >
                <Input id="topicsTitle" key="topicsTitle" defaultValue={fieldsValues.topicsTitle} />
            </FormItem>
        </Row>
    </Card>
}

export default TopicSection;



// WEBPACK FOOTER //
// ./src/pages/homepage-form/libraries/topicSection.tsx